import { ActionDataType } from '../BaseCustomAction';
import {
  BaseQuestionGeneration,
  QUESTION_ACTION_TAGS,
  QuestionGenerationInputData,
} from './BaseQuestionGeneration';

/**
 * This custom action is used to send the stats of the question generation
 * like the number of questions generated, the number of questions submitted,
 * the number of questions deleted, the number of questions failed, etc.
 */
class QuestionsGenerationAction extends BaseQuestionGeneration {
  name = 'Questions Generation';

  type = ActionDataType.Action;

  prepareTags(
    input: QuestionGenerationInputData & {
      requestedCount: number;
      generatedCount: number;
      failedCount: number;
    },
  ): Record<string, any> {
    // Get base tags from parent
    const baseTags = super.prepareTags(input);

    // Add stat-specific tags
    return {
      ...baseTags,
      [QUESTION_ACTION_TAGS.STATUS]: input.value === 1 ? 'success' : 'error',
      [QUESTION_ACTION_TAGS.REQUESTED_COUNT]: input.requestedCount,
      [QUESTION_ACTION_TAGS.GENERATED_COUNT]: input.generatedCount,
      [QUESTION_ACTION_TAGS.FAILED_COUNT]: input.failedCount,
      [QUESTION_ACTION_TAGS.GENERATION_TIME]: input.generationTime,
    };
  }
}

export default QuestionsGenerationAction;
